export default __webpack_public_path__ + "static/media/dropdown-cap.c39fdcc0.svg";